<div fxFlex matTooltip="Cannot find any modifiers for this CPT code" [matTooltipDisabled]="modifiersControl.enabled">
  <mat-form-field appearance="fill" fxFlex>
    <mat-label>{{ code }}: Code Modifiers </mat-label>
    <mat-select
      multiple
      [formControl]="modifiersControl"
      (selectionChange)="onModifierSelected($event.value)"
    >
      <mat-option>
        <ngx-mat-select-search
          [formControl]="filterControl"
          placeholderLabel="Search Modifiers"
          noEntriesFoundLabel="No matching modifiers found"
        ></ngx-mat-select-search>
      </mat-option>
      <mat-option
        *ngFor="let modifier of filteredModifiers$ | async"
        [value]="modifier.code"
      >
        [{{ modifier.code }}] {{ modifier.abbreviation }}
      </mat-option>
    </mat-select>

    <mat-hint *ngIf="(topModifiers$ | async)?.length > 0">
      <ng-container *ngIf="modifiersShown$ | async as modifiersShown">
        <ng-container *ngIf="modifiersShown === 'top'">
          Showing top modifiers only.
        </ng-container>
        <ng-container *ngIf="modifiersShown === 'supported'">
          Showing all supported modifiers.
        </ng-container>
      </ng-container>

      <span class="text-link" (click)="modifiersShown$.next('top')">
        Show top
      </span>

      <span class="text-link" (click)="modifiersShown$.next('supported')">
        Show supported
      </span>
      <!-- <span class="text-link" (click)="availableModifiers('all')">Show all</span> -->
    </mat-hint>
  </mat-form-field>
</div>
